import React from 'react';
import { PortaledLayer } from '../PortaledLayer';
import {
  DIALOG_BODY,
  DIALOG_FOOTER,
  DIALOG_HEADER,
  DIALOG_OVERLAY,
  DIALOG_OVERLAY_RACE_STACKED,
  DIALOG_PANEL,
} from './uiTokens';
import type { DialogProps } from './types/UIProps';

export type { DialogProps };

export function Dialog({
  open,
  onClose,
  children,
  panelClassName = 'max-w-xl',
  closeOnBackdrop = false,
  stackedAboveRacePortal = false,
  overlayZIndex,
}: DialogProps): React.ReactElement | null {
  if (!open) return null;

  return (
    <PortaledLayer>
      <div
        className={stackedAboveRacePortal ? DIALOG_OVERLAY_RACE_STACKED : DIALOG_OVERLAY}
        style={typeof overlayZIndex === 'number' ? { zIndex: overlayZIndex } : undefined}
        data-race-stacked-overlay={stackedAboveRacePortal ? '' : undefined}
        role="presentation"
        onClick={closeOnBackdrop && onClose ? onClose : undefined}
      >
        <div
          role="dialog"
          aria-modal="true"
          className={`${DIALOG_PANEL} ${panelClassName}`.trim()}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </PortaledLayer>
  );
}

export function DialogHeader({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return <div className={`${DIALOG_HEADER} ${className}`.trim()}>{children}</div>;
}

export function DialogBody({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return <div className={`${DIALOG_BODY} ${className}`.trim()}>{children}</div>;
}

export function DialogFooter({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return <div className={`${DIALOG_FOOTER} ${className}`.trim()}>{children}</div>;
}
